import { Controller } from "@hotwired/stimulus"

// Texts page: while a slot's label is hovered, marks the preview's blocks that
// carry its data-school-text-slot, inside the mail iframe too. The mark is
// inline style: the mail preview is its own document without our CSS.
// Mechanism and tests: documentation/development_manual/school-texts.md.
export default class extends Controller {
  connect() {
    this.marked = new Map()
  }

  disconnect() {
    this.hide()
  }

  show({ params: { slot } }) {
    this.hide()
    this.blocks(slot).forEach((block) => {
      this.marked.set(block, block.getAttribute("style"))
      block.style.outline = "2px solid #f59e0b"
      block.style.outlineOffset = "4px"
      block.style.backgroundColor = "#fef3c7"
      block.style.borderRadius = "2px"
    })
  }

  hide() {
    this.marked.forEach((previous, block) => {
      if (previous === null) {
        block.removeAttribute("style")
      } else {
        block.setAttribute("style", previous)
      }
    })
    this.marked.clear()
  }

  blocks(slot) {
    const selector = `[data-school-text-slot="${CSS.escape(slot)}"]`
    const documents = [this.element]
    // contentDocument is null for a frame the page may not read (another origin); skip it.
    this.element.querySelectorAll("iframe").forEach((frame) => {
      if (frame.contentDocument) documents.push(frame.contentDocument)
    })
    return documents.flatMap((root) => Array.from(root.querySelectorAll(selector)))
  }
}
